module.exports = __webpack_public_path__ + "img/Phoenix_dactylifera.99670259.jpg";